import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FeatureFlagService } from './shared/feature-flag.service';

enum LanguageNames {
  Thai = 'th',
  Malay = 'ma',
  French = 'fr',
  Spanish = 'es',
  English_US = 'en-US',
  Chinese_Simplified = 'zh-CN',
  Chinese_Traditional = 'zh-TW',
  German = 'de',
  Brazilian_Portuguese = 'pt-BR'
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private featureFlagService: FeatureFlagService
  ) {
    this.featureFlagService.getAllFeatureFlags();
    this.initTranslate();
  }

  private initTranslate() {
    this.translate.addLangs([
      LanguageNames.English_US,
      LanguageNames.French,
      LanguageNames.Malay,
      LanguageNames.Thai,
      LanguageNames.Chinese_Traditional,
      LanguageNames.Chinese_Simplified,
      LanguageNames.German,
      LanguageNames.Brazilian_Portuguese
    ]);
    this.translate.setDefaultLang(LanguageNames.English_US);
    // using getBrowserCultureLang() instead of getBrowserLang() so we can see detailed lang name
    const browserLanguageDetail = this.translate.getBrowserCultureLang();
    this.translate.use(
      browserLanguageDetail.match(/en-US|fr|es|zh-CN|ms|zh-TW|th|de|pt-BR/)
        ? browserLanguageDetail
        : LanguageNames.English_US
    );
  }
}
